import React from 'react';
import { Link } from 'react-router-dom';
import { RelatedProject } from '../types';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/UI/Button';

interface RelatedProjectsProps {
  projects: RelatedProject[];
}

const RelatedProjects = ({ projects }: RelatedProjectsProps) => {
  return (
    <div className="bg-surface rounded-xl p-6 lg:p-8 elevation-2 mb-8">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-2xl font-bold text-text-primary">Related Projects</h2>
        <Link to="/projects-showcase">
          <Button variant="outline" iconName="ArrowRight" iconPosition="right">
            View All Projects
          </Button>
        </Link>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {projects.map((project) => (
          <div key={project.id} className="group border border-border rounded-lg overflow-hidden hover:elevation-2 transition-smooth">
            <div className="aspect-video overflow-hidden">
              <Image
                src={project.image}
                alt={project.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-smooth"
              />
            </div>

            <div className="p-4">
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-accent font-medium uppercase tracking-wide">
                  {project.categories.join(' & ')}
                </span>
                <Icon name="ExternalLink" size={14} className="text-text-secondary" />
              </div>

              <h3 className="text-lg font-semibold text-text-primary mb-2 group-hover:text-accent transition-smooth">
                {project.title}
              </h3>

              <p className="text-sm text-text-secondary mb-4 line-clamp-2">
                {project.description}
              </p>

              <div className="flex flex-wrap gap-1 mb-4">
                {project.technologies.slice(0, 3).map((tech, index) => (
                  <span
                    key={index}
                    className="px-2 py-1 bg-muted text-xs text-text-secondary rounded"
                  >
                    {tech}
                  </span>
                ))}
                {project.technologies.length > 3 && (
                  <span className="px-2 py-1 bg-muted text-xs text-text-secondary rounded">
                    +{project.technologies.length - 3}
                  </span>
                )}
              </div>

              <Link to={project.link} className="block">
                <Button variant="ghost" size="sm" className="w-full">
                  View Project
                </Button>
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelatedProjects;